import styled from "styled-components";

const TabFill = styled.div`
  flex: 1;
  border-bottom: 1px solid ${(props) => props.theme.palette.divider};
`;

export default TabFill;
